mapboxgl.accessToken = 'pk.eyJ1IjoiZXNwaS1sZWlsYSIsImEiOiJjbWF2YnkweHowMzBhMmxxMG5rbWQ5djh5In0.E78Gw2Wtd8YE4Zt95ruCkw';

const mapInstances = [];

function getResponsiveSettings() {
  const width = window.innerWidth;

  let zoomLevel, centerLevel;

  if (width < 720) {
    zoomLevel = 10;
    centerLevel = { lat: -34.6037, lng: -58.3816 };
  } else if (width < 990) {
    zoomLevel = 11;
    centerLevel = { lat: -34.6037, lng: -58.3816 };
  } else {
    zoomLevel = 13;
    centerLevel = { lat: -34.6037, lng: -58.3816 };
  }

  return { zoomLevel, centerLevel };
}

function forceMapResize(instance) {
  if (!instance) return;
  const map = instance.map;
  const container = map.getContainer();

  container.style.display = 'none';
  container.offsetHeight; // force reflow
  container.style.display = '';

  setTimeout(() => {
    map.resize();
  }, 50);
}

function initMaps() {
  markerData.forEach((location, index) => {
    const containerId = `map-${index}`;
    const container = document.getElementById(containerId);
    if (!container) return;

    const { zoomLevel } = getResponsiveSettings();

    const map = new mapboxgl.Map({
      container: containerId,
      style: 'mapbox://styles/mapbox/light-v10',
      center: location.coordinates, 
      zoom: zoomLevel,
      scrollZoom: false, 
      dragPan: false,   
      interactive: false
    });

    // Disable all interactions
    map.scrollZoom.disable();
    map.boxZoom.disable();
    map.doubleClickZoom.disable();
    map.dragRotate.disable();
    map.dragPan.disable();
    map.keyboard.disable();
    map.touchZoomRotate.disable();

    const markers = [];

    markerData.forEach((loc, i) => {
      const el = document.createElement('div');
      el.className = 'marker-c';
      if (i === index) el.classList.add('active');

      el.addEventListener('click', () => {
        swiper8.slideTo(i);
      });

      const marker = new mapboxgl.Marker(el)
        .setLngLat(loc.coordinates)
        .addTo(map);

      markers.push({ el, marker });
    });

    map.on('load', () => {
      map.setPaintProperty('water', 'fill-color', '#D4DDF0');
      map.setPaintProperty('land', 'background-color', '#F1F1F1');
      map.setPaintProperty('landuse', 'fill-color', '#F1F1F1');
      map.setPaintProperty('background', 'background-color', '#F1F1F1');
    });

    mapInstances.push({ map, markers });
  });
}



function setActiveMarker(activeIndex) {
  mapInstances.forEach((instance) => {
    instance.markers.forEach((m, i) => {
      m.el.classList.toggle('active', i === activeIndex);
    });
  });
}

let swiper8;

$(function () {
   swiper8 = new Swiper(".cryoMap", {
    slidesPerView: 1,
    spaceBetween: 30,
    effect: "fade",
    navigation: {
      nextEl: ".map-next",
      prevEl: ".map-prev",
    },
    pagination: {
      el: ".map-pag .swiper-pagination",
      clickable: true,
      renderBullet: function (index, className) {
        const slides = document.querySelectorAll('.swiper-slide');
        const label = slides[index].getAttribute('custom-label') || `Slide ${index + 1}`;
        return `<span class="${className}">${label}</span>`;
      },
    },
    on: {
      init: function () {
        initMaps();
        setActiveMarker(this.activeIndex);
        setTimeout(() => {
          requestAnimationFrame(() => {
            const instance = mapInstances[this.activeIndex];
            forceMapResize(instance);
          });
        }, 150);
      },
      slideChange: function () {
        setActiveMarker(this.activeIndex);
        setTimeout(() => {
          requestAnimationFrame(() => {
            const instance = mapInstances[this.activeIndex];
            forceMapResize(instance);
          });
        }, 150);
      }
    }
  });

  // Handle window resize
  window.addEventListener('resize', () => {
    const { zoomLevel } = getResponsiveSettings();

    mapInstances.forEach((instance, index) => {
      const markerCenter = markerData[index].coordinates;
      instance.map.setZoom(zoomLevel);
      instance.map.setCenter(markerCenter);
      forceMapResize(instance);
    });
  });

});